export const encodeUrlParams = (url: string): string => {
  const idx = url.indexOf('?');
  if (idx === -1) return url;
  const path = url.slice(0, idx);
  const params = new URLSearchParams(url.slice(idx + 1));
  return `${path}?${params.toString()}`;
};
